import React,{Component} from "react";
import axios from 'axios';
import { data } from "jquery";


class Contact_form extends React.Component{
   
   
 //   submitFormdata = e => {
 //       e.preventDefault()
 //       console.log(this.state);
 //      // axios.post("http://localhost/rs-web-master/rest/contacts/add/api_key/rappikey/", this.state)
 //      //      .then(response => {
 //      //          console.log(response)
 //      //      })
 //      //      .catch(error => {
 //      //          console.log(error)
 //      //      })
 //   }


    constructor() {
        super();
        this.state = {
            form_msg: '',
            contact_name: '',
            contact_email: '',
            contact_phone: '',
            contact_message: '',
        };
      }

      onChange = (e) => {
        this.setState({ [e.target.name]: e.target.value });
      }

      onSubmit = (e) => {
        e.preventDefault();
        //console.log(this.state);

        var formData = {
            contact_name: this.state.contact_name,
            contact_email: this.state.contact_email,
            contact_phone: this.state.contact_phone,
            contact_message: this.state.contact_message,
        };
    
            //http://localhost/rs-web-master/index.php/rest/contacts/add/api_key/rappikey/

            //https://api.test.takengo.risee.in/index.php/rest/contacts/add/api_key/1fWwZNrzUiOW2pWEffgy3fXS1R7khL/


        fetch("https://api.test.takengo.risee.in/index.php/rest/contacts/add/api_key/1fWwZNrzUiOW2pWEffgy3fXS1R7khL/", {
            method: 'POST',
            headers:{
                Accept: 'application/json',
                'Content-Type': 'application/json'
              }, 
            body: JSON.stringify(formData)
          })
          .then(response => response.json())
          .then(data => this.setState({ form_msg:data.status, contact_name: '', contact_email: '', contact_phone: '', contact_message: '',}))
          .catch(error => console.log(error));


        
         
//        var formData = JSON.stringify(this.state);
//        //console.log(formData);
//
//        axios.post("http://localhost/rs-web-master/submit_contact/", this.state,{
//                    headers: {
//                        "Accept": 'application/json',
//                        "content-type": "application/json",
//                    },
//                })
//            .then(function(res){
//                console.log(res);
//            })
//            .catch(function(err){
//                console.log(err);
//            });
      }



 
    render(){
        const {form_msg, contact_name, contact_email, contact_phone, contact_message} = this.state;
        return(
            <div>
                <h3 className="text-center text-success">{form_msg=='success' ? 'Success. Message sent.' : null}</h3>
                <form  onSubmit={this.onSubmit}>
                	<div className="row">
                	  <div className="col-md-6">
                		  <input name="contact_name" type="text" id="contact_name" placeholder="Frist Name" value={contact_name}  onChange={this.onChange} required />                
                	  </div>
                	  <div className="col-md-6">
                		  <input name="contact_email" type="email" id="contact_email" placeholder="Email Address" value={contact_email}  onChange={this.onChange} required />                
                	  </div>
                	  <div className="col-md-6">
                		  <input name="contact_phone" type="text" id="contact_phone" placeholder="Number" value={contact_phone}   onChange={this.onChange} required />                
                	  </div>
                	  <div className="col-md-12">
                		  <textarea name="contact_message" id="contact_message" cols="40" rows="3" placeholder="Message..." spellCheck="true"  value={contact_message} onChange={this.onChange} required></textarea>
                	  </div>
                	</div>
                	<div className="utf-centered-button margin-bottom-10">	
                        {/*<button type="button" className="submit button" onClick={this.saveData}>Send Message</button>*/}
                		<input type="submit" className="submit button" id="submit" value="Submit Message" />
                	</div>
                </form>
            </div>
        )
    }
}

export default Contact_form;
